import type { Story3ExpertId } from '../../types';

export interface Story3ExpertDef {
  id: Story3ExpertId;
  title: string;
  description: string;
}

export const STORY3_EXPERTS: readonly Story3ExpertDef[] = [
  {
    id: 'detektiv',
    title: 'Detektiv',
    description:
      'Efterforsker teksten: fakta, huller, modstrid og en hypotese om hvad der skete.',
  },
  {
    id: 'forfatter',
    title: 'Forfatter',
    description: 'Litterær læsning — stemme, billeder og hvad der bærer eller svækter.',
  },
  {
    id: 'psykolog',
    title: 'Psykolog',
    description: 'Case-notat om motivation, relationer og det usagte i personerne.',
  },
  {
    id: 'debator',
    title: 'Debatør',
    description: 'Påstand, styrke og angreb — teksten som argument der skal kunne holde.',
  },
  {
    id: 'sprogforsker',
    title: 'Sprogforsker',
    description: 'Analyserer ord, rytme og register — hvad sproget gør ved budskabet.',
  },
  {
    id: 'advokat',
    title: 'Advokat',
    description: 'Sagsresumé og anmærkninger: hvad hænger sammen, hvad falder fra hinanden.',
  },
  {
    id: 'gymnasielaerer',
    title: 'Litteraturkritiker',
    description: 'Anmeldelse af teksten som prosa — tema, form og dom.',
  },
  {
    id: 'jesus',
    title: 'Jesus',
    description:
      'Læser din historie som en lignelse — billeder og spørgsmål i evangelisk stil.',
  },
  {
    id: 'antropolog',
    title: 'Antropolog',
    description: 'Feltnotat om sted, vaner og hvad der holder verden i teksten sammen.',
  },
  {
    id: 'dramaturg',
    title: 'Dramaturg',
    description: 'Manuskriptlæsning: scener, konflikt og hvad dramaet mangler.',
  },
] as const;

export function story3ExpertDef(id: Story3ExpertId): Story3ExpertDef {
  return STORY3_EXPERTS.find((e) => e.id === id) ?? STORY3_EXPERTS[0]!;
}

export function isStory3ExpertId(raw: string): raw is Story3ExpertId {
  return STORY3_EXPERTS.some((e) => e.id === raw);
}
